import React from 'react';
import AdminLayout from '../../../../components/Layout/AdminLayout';
import ManageCompany from './ManageCompany';

async function action({ store, largeProjectsEnabled }) {
  const isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;

  // LARGE PROJECTS FLAG: when OFF this admin LP route is unreachable -> redirect
  // home (mirrors bigProjects/index.js; non-LP admin routes untouched).
  if (!largeProjectsEnabled) {
    return { redirect: '/' };
  }

  if (!isAdminAuthenticated) {
    return { redirect: '/login' };
  }

  return {
    title: 'Manage Company — Big Projects',
    component: (
      <AdminLayout>
        <ManageCompany />
      </AdminLayout>
    ),
  };
}

export default action;
